module.exports = __webpack_public_path__ + "img/business_29.a980cb12.jpg";